import { motion } from "framer-motion";

const TOKENS = [
  "SOLAR EPC",
  "MEP ENGINEERING",
  "ENERGY OPTIMIZATION",
  "POWER DISTRIBUTION",
  "DESIGN · BUILD · COMMISSION",
  "GRID-TIE · HYBRID · OFF-GRID",
  "BATTERY BACKUP",
  "AUDIT · TELEMETRY · CTRL",
  "REAL ESTATE · COMMERCIAL · INSTITUTIONAL",
];

const Row = () => (
  <>
    {TOKENS.map((t, i) => (
      <span
        key={`${t}-${i}`}
        className="inline-flex items-center gap-4 font-mono-spec text-xs tracking-[0.28em] uppercase whitespace-nowrap"
        style={{ color: "var(--text-soft)" }}
      >
        <span>{t}</span>
        <span
          className="inline-block w-1.5 h-1.5"
          style={{
            background: i % 2 === 0 ? "var(--accent-blue)" : "var(--accent-crimson-hover)",
            transform: "rotate(45deg)",
          }}
          aria-hidden
        />
      </span>
    ))}
  </>
);

const Marquee = () => (
  <motion.div
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 0.6 }}
    className="relative overflow-hidden border-y"
    style={{
      borderColor: "var(--border)",
      background: "var(--bg)",
    }}
    data-testid="marquee"
  >
    <span
      aria-hidden
      className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 z-10"
      style={{
        background: "linear-gradient(90deg, var(--bg), transparent)",
      }}
    />
    <span
      aria-hidden
      className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 z-10"
      style={{
        background: "linear-gradient(-90deg, var(--bg), transparent)",
      }}
    />
    <div
      className="marquee-track flex items-center gap-10 py-4"
      style={{ width: "max-content" }}
    >
      <Row />
      <Row />
    </div>
  </motion.div>
);

export default Marquee;
